/**
 * 对比柱中柱状图验证配置
 * 为新 ValidationEngine 提供验证规则
 */

import type { ValidationConfig } from '../../../core/dataProcessor/types';

// 🆕 为新 ValidationEngine 导出的配置
export const contrastDoubleBarValidationConfig: ValidationConfig = {
  fields: [
    { field: 'x', type: 'string', required: true },
    { field: 'y', type: 'number', required: true },
    { field: 'z', type: 'string', required: true }
  ],
  businessRules: [
    {
      name: 'contrast-double-bar-exact-categories',
      validator: (data, layer) => {
        if (!Array.isArray(data)) {
          return true;
        }
        const { encoding } = layer;
        const zValues = new Set(data.map(item => String(item[encoding?.z as string] || '')));
        return zValues.size === 2;
      },
      message: 'Contrast double bar chart requires exactly 2 unique values in z field',
      suggestion: 'Provide data with exactly 2 categories in the z field for proper comparison',
      severity: 'error'
    },
    {
      name: 'contrast-double-bar-sufficient-data',
      validator: data => Array.isArray(data) && data.length >= 4,
      message: 'Contrast double bar chart requires at least 4 data points',
      suggestion: 'Provide at least 4 data points (2 x-values × 2 z-categories minimum)',
      severity: 'warning'
    },
    {
      name: 'contrast-double-bar-balanced-data',
      validator: (data, layer) => {
        if (!Array.isArray(data)) {
          return true;
        }
        const { encoding } = layer;
        const zValues = new Set(data.map(item => String(item[encoding?.z as string] || '')));

        if (zValues.size !== 2) {
          return true;
        }

        // 检查两个分类的数据量是否相对平衡
        const [z1, z2] = Array.from(zValues);
        const z1Count = data.filter(
          item => String(item[encoding?.z as string] || '') === z1
        ).length;
        const z2Count = data.filter(
          item => String(item[encoding?.z as string] || '') === z2
        ).length;

        const ratio = Math.min(z1Count, z2Count) / Math.max(z1Count, z2Count);
        return ratio >= 0.3;
      },
      message:
        'Contrast double bar chart works best with relatively balanced data between categories',
      suggestion:
        'Ensure both z-field categories have reasonable amounts of data for meaningful comparison',
      severity: 'warning'
    }
  ]
};
